module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Squad/images/tr-disabled-pattern.5dad720b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Squad/images/tr-disabled-pattern.png
// module id = 2744
// module chunks = 11